// extracted by mini-css-extract-plugin
export default {"wrapper":"_2-z","play":"a3-z"};